export default "__VITE_ASSET__CQJzR36l__"